import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BuscadoresExModule } from './buscadores/buscadoresEx.module';
import { SolicitudesExModule } from './solicitudes/solicitudesEx.module';
import { AtestacionesModule } from './atestaciones/atestaciones.module';
import { VerificarCertificadoService } from './certificado/verificar-certificado.service';
import { VerificarCertificadoComponent } from './certificado/verificar-certificado.component';
import { CpeModule } from './cpe/cpe.module';

@NgModule({
    declarations: [VerificarCertificadoComponent],
    imports: [
        SolicitudesExModule,
        AtestacionesModule,
        CpeModule,
        BuscadoresExModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule.forRoot([
            { path: 'exportacion/verificarcertificado', component: VerificarCertificadoComponent },
            { path: 'exportacion/verificarcertificado/:token', component: VerificarCertificadoComponent },
        ]),
    ],
    providers: [VerificarCertificadoService],
    exports: [],
})
export class ExportacionModule {}
